export class AxxonIntelectIntegrationCategoryFacilityCode {
    public id: number;
    public categoryId: number;
    public facilityId: string;
    public parentId: string;
    public validityLength: number;
}
